// extracted by mini-css-extract-plugin
var _1 = "Logo-module_logo__An97KA";
export { _1 as "logo" }
